import { Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedEventDescriptionsAtom, selectedVisEventsAtom } from '@/atoms/vis/selection';
import { useFormatVideoEvents } from '@/hooks/useFormatVideoEvents';
import { useVideoDataForEvents } from '@/hooks/useVideoDataForEvents';
import { VideoPlayer } from './VideoPlayer';

const PitchSelectVideoPlayerWithData = () => {
  const selectedVisEvents = useAtomValue(selectedVisEventsAtom);
  const eventDescriptions = useAtomValue(selectedEventDescriptionsAtom);
  const { videoIds, unavailableVideosCount, ref } = useVideoDataForEvents<HTMLSpanElement>(selectedVisEvents || []);

  const videoEvents = useFormatVideoEvents(videoIds, eventDescriptions);

  return (
    <span ref={ref}>
      <VideoPlayer videoEvents={videoEvents} unavailableVideosCount={unavailableVideosCount} />
    </span>
  );
};

export const PitchSelectVideoPlayer = () => {
  const { t } = useTranslation('video');

  return (
    <Suspense fallback={<Typography variant="bodyMedium">{t('loadingVideo')}</Typography>}>
      <div className="p-4">
        <PitchSelectVideoPlayerWithData />
      </div>
    </Suspense>
  );
};
